import { useState,useMemo, useCallback ,useEffect} from 'react';
import Constants from '../Constants';
import useAxios from './useAxios';
import { dateToInput, addMonths, dateInputToUTC } from '@demandproai/shared';


const useCompanyForm = (toggleIsSubmittingForm) => {
    const [isloader, setIsLoader] = useState(null);
    const { postData,getData } = useAxios();
      const [showPassword, setShowPassword] = useState(null);
      const [profilefileName, setprofilefileName] = useState({
        fileName: "",
        imageUrl: null
      });
      const [superAdmin, setSuperAdmin] = useState([])

      // default renewal date is 1 month from now
      const nextMonth = useMemo(() => dateToInput(addMonths(new Date(), 1)), []);

      const onProfileUpload = (files, formik) => {
        const newFiles = Array.isArray(files.file) ? files.file : [files.file];
        const selectedFile = newFiles[0];
        if (!selectedFile) return;
        setprofilefileName(selectedFile.name);
        setprofilefileName((prev) => ({
          ...prev,
          fileName: selectedFile.name,
          imageUrl: URL.createObjectURL(selectedFile)
        }));
        formik.setFieldValue('companyLogo', selectedFile);
      };
    
      const toggleShowPassword = () => setShowPassword(!showPassword);
    
      const removeEmailFields = (formik, index) => {
        const accountantemail = formik.values.accountantemail
        const updatedAccountantEmail = accountantemail.filter((_, x) => x !== index)
        formik.setFieldValue('accountantemail', updatedAccountantEmail)
      }
    
      const toggleDelayedPayment = (e, formik) => {
        formik.setFieldValue('isDelayedPayment', e.target.checked)
      }

  const getSuperAdminUser = useCallback(async () => {
    const { success, data } = await getData(`${Constants.ApiUrl.user.superAdminUser}`);
    console.log('data', data)
    if (success) {
      setSuperAdmin(data)
    }
  }, [getData])


  useEffect(() => {
    getSuperAdminUser()
  }, [getSuperAdminUser])


    const getAddFormData = (values) => {
        console.log("Form values:", values);
        let formData = new FormData();
        formData.append('firstName', values?.firstName)
        formData.append('lastName', values?.lastName)
        formData.append('companyName', values?.companyName)
        formData.append('companyPhoneNumber', values?.companyPhonenumber)
        formData.append('companyAddress', values?.companyAddress)
        formData.append('contactEmail', values?.emailAddress)
        formData.append('dataBaseUser', values?.databaseUser)
        formData.append('databaseIP', values?.databaseIp)
        formData.append('taxiationID', values?.taxId)
        formData.append('dataBasePassword', values?.databasePassword)
        formData.append('domainName', values?.domainName)
        formData.append('contactNumber', values?.contactPhonenumber)
        formData.append('companyLogo', values?.companyLogo)
        formData.append('contractDetails', values?.ContractDetails)
        formData.append('accountantname', values?.accountantname)
        formData.append('accountantemail', JSON.stringify(values?.accountantemail))
        formData.append('monthlyPrice', values?.monthlyPrice)
        formData.append('demandsPerMonth', values?.demandsPerMonth)
        formData.append('usersLimit', values?.usersLimit)
        formData.append('status', values?.status);
        formData.append('isDelayedPayment', values?.isDelayedPayment ? values?.isDelayedPayment : false)
        formData.append("costPerAdditionalDemand", values?.costPerAdditionalDemand);
        formData.append("costPerAdditionalUser", values?.costPerAdditionalUser);
        formData.append("chargeAdditionalPlaintiffs", values?.chargeAdditionalPlaintiffs);
        formData.append("subscriptionRenewalDate", dateInputToUTC(values?.subscriptionRenewalDate));
        formData.append("contractRenewalDate", dateInputToUTC(values?.contractRenewalDate));
        formData.append("tier", values.tier);
        formData.append("tierNotes",values.tierNotes);
        formData.append("startedOn", dateInputToUTC(values.startedOn));
        formData.append("accountExecutive", values.accountExecutive);
        formData.append("commission", values.commission);
        formData.append("isAnnual", values.isAnnual ? values.isAnnual : false);
        formData.append("hsCompanyId", values?.hsCompanyId);
        formData.append("homeState", values?.homeState);
        return formData;
    };

    const appendEditFormFields = (formData, values, companyId) => {
        formData.append('rollOverCredits', values?.rollOverCredits);
        formData.append('remainingDemand', values?.remainingDemand);
        formData.append('companyId', companyId);
        return formData;
    }

    const onSubmit = (formData, url) => {
        setIsLoader(true)
        postData(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            showErrorToast: true,
        }).then((res) => {
            setIsLoader(false)
            if (res.success) {
                toggleIsSubmittingForm()
            }
        })
    }

    const onSubmitAddCompany = (values) => {
        const url = Constants.ApiUrl.companies.addCompanies;
        const formData = getAddFormData(values);
        onSubmit(formData, url);
    }

    const onSubmitEditCompany = (values, companyId) => {
        console.log("Submitting company edit");
        const url = Constants.ApiUrl.companies.updatecompanies;
        let formData = getAddFormData(values);
        formData = appendEditFormFields(formData, values, companyId);
        onSubmit(formData, url);
    }

    const onback = () => {
        toggleIsSubmittingForm()
    }

    return {
        isloader,
        profilefileName,
        showPassword,
        nextMonth,
        superAdmin : superAdmin.map((values) => ({ text: values.firstName, value: values._id })),
        onSubmitAddCompany,
        onSubmitEditCompany,
        onProfileUpload, 
        toggleShowPassword,
        removeEmailFields,
        toggleDelayedPayment,
        onback,
        setShowPassword  
    }

}

export default useCompanyForm;